import React, {useEffect, useState} from 'react';
import { Alert, Modal, Button, Card, Spinner, Row, Col, Form, Table } from 'react-bootstrap';
import { Typeahead } from 'react-bootstrap-typeahead';
import { useDispatch, useSelector } from "react-redux";
import { withRouter } from 'react-router-dom';
import toastr from 'toastr';
import { getUsers } from "../../redux/auth/actions";
import {
  saveWorkFlowEmp,
  resetSuccessMessage
  //getEmployeesWorkFlow,
  //deleteWorkFlowEmp,
} from "../../redux/on&offBoarning/Mantenimientos/WorkFlowEmp/actions";
import { getResponsables } from '../../redux/climalaboral/campaña/action';

const WorkFlowEmployees = props => {
  //*States
  const [userSelected, setUserSelected] = useState([]);
  const [respSelected, setRespSelected] = useState([]);
  const [validated, setValidated] = useState(false);
  const [isUserValid, setIsUserValid] = useState(false);
  const [isRespValid, setIsRespValid] = useState(false);
  const [workflowUsers, setWorkflowUsers] = useState([]);
  //*Redux
  const {loadingAuth, users} = useSelector(store => store.auth);
  const {loadingWorkFlow, saveLoading, error, successMessage} = useSelector(store => store.wflowempleados);
  const {responsable, responsableLoading} = useSelector((store) => store.campaña);
  const userRoles = useSelector((store) => store.auth.userRoles);

  //*variables
  const dispatch = useDispatch();
  let usersOptions = [];
  users.map((user) => {
    usersOptions = [...usersOptions, {id: user.id, label: `${user.username}-${user.first_name} ${user.last_name}`}]
  });
  let responsableOptions = [];
  responsable &&
    responsable.map((user) => {
      responsableOptions = [
        ...responsableOptions,
        {
          id: user.id,
          label: `${user.username}-${user.first_name} ${user.last_name}`,
        },
      ];
    });
  //* Methods
  useEffect(() => {
    dispatch(getUsers({}));
    // dispatch(getResponsables({}));
    dispatch(resetSuccessMessage());
    //dispatch(getEmployeesWorkFlow({}));
  }, []);

  useEffect(() => {
    let filters = {}
    if(userRoles.includes("Responsable_OnBoarding") || userRoles.includes("Responsable_OffBoarding")){
      filters.usuario_x_empresa = "si"
    }
    if(props.item && props.item.tipo_workflow === 1){
      filters.rol_responsable = "Responsable_OnBoarding"
      dispatch(getResponsables(filters));
    }
    if(props.item && props.item.tipo_workflow === 2){
      filters.rol_responsable = "Responsable_OffBoarding"
      dispatch(getResponsables(filters));
    }
  }, [props.item, userRoles])
  

  const handleSubmit = e => {
    e.preventDefault();
    const form = e.currentTarget;
    if (form.checkValidity() === false) {
      setValidated(true);
      return;
    }
    if (userSelected.length === 0){
      //setValidated(true);
      setIsUserValid(true);
      return;
    }else{
      //setValidated(false);
      setIsUserValid(false);
    }

    if (respSelected.length === 0){
      //setValidated(true);
      setIsRespValid(true);
      return;
    }else{
      //setValidated(false);
      setIsRespValid(false);
    }
    try {
      const existItem = workflowUsers.find(rowItem => rowItem.user.id === userSelected[0].id && rowItem.resp.id === respSelected[0].id);
      if(existItem){
        toastr.info('El usuario y responsable ya han sido agregados', '', {
          progressBar: true,
          rtl: true,
        });
        return;
      }
      if(userSelected[0].id === respSelected[0].id){
        toastr.info('El usuario y el responsable, no pueden ser el mismo.', '', {
          progressBar: true,
          rtl: true,
        });
        return;
      }
    } catch (error) {
      toastr.info('El usuario o responsable, no son validos', '', {
        progressBar: true,
        rtl: true,
      });
    }

    setWorkflowUsers([...workflowUsers, { user: userSelected[0], resp: respSelected[0] }]);
    setUserSelected([]);
    setRespSelected([]);

    
    // const userExists = workflowUsers.find(item => item.id === userSelected[0].id);
    // const repExists = workflowUsers.find(item => item.id === respSelected[0].id);
    // if(!userExists && !repExists){
    //   setWorkflowUsers([...workflowUsers, ...userSelected]);
    // }
  }

  const handleRemoveUserWork = ind => {
    const wUsers = workflowUsers.slice();
    wUsers.splice(ind, 1);
    setWorkflowUsers(wUsers);
  }

  const handleSaveWorkFlowEmployees = () => {
    let oWorkflowUsers = [];
    workflowUsers.map(item => (
      oWorkflowUsers.push({empleado: item.user.id, responsable: item.resp.id})
    ));

    const req = {
      empleados: oWorkflowUsers,
      workflow: props.item.id,
    };
    
    dispatch(saveWorkFlowEmp(req, setWorkflowUsers));
    props.handleClose()
  }

  return (
    <Modal size="lg" show={props.show} onHide={props.handleClose}>
      <Modal.Header closeButton>
        <Modal.Title>WorkFlow Usuarios</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Card className="border-0">
          <Card.Body>
            {
              !!error && (
                <Alert variant="danger" className="mt-4 mb-1">
                  {error}
                </Alert>
              )
            }
            {
              !!successMessage && (
                <Alert variant="success" className="my-3 mb-1">
                  <p>WorkFlows asignados con éxito</p>
                </Alert>
              )
            }
            <Row>
              <Col sm={12} md={5}>
                <Form onSubmit={handleSubmit} noValidate validated={validated}>
                  <Row className="align-items-end">
                    <Col sm={ loadingAuth ? 10 : 12}>
                      <Form.Label className="ml-1">Usuario</Form.Label>
                      <Typeahead
                        isInvalid={isUserValid}
                        placeholder="Usuario"
                        options={usersOptions}
                        onChange={selected => setUserSelected(selected)} 
                        selected={userSelected}>
                      </Typeahead>
                    </Col>
                    {
                      loadingAuth && (
                        <Col sm={1}>
                          <Spinner animation="border" size="sm" />
                        </Col>
                      )
                    }
                  </Row>
                  {
                    isUserValid && (
                      <small className="text-danger">**Campo requerido</small> 
                    )
                  }
                  <Row className="align-items-end mt-2">
                    <Col sm={ responsableLoading ? 10 : 12}>
                      <Form.Label className="ml-1">Responsable</Form.Label>
                      <Typeahead
                        isInvalid={isRespValid}
                        placeholder="Responsable"
                        options={responsableOptions}
                        onChange={selected => setRespSelected(selected)} 
                        selected={respSelected}>
                      </Typeahead>
                    </Col>
                    {
                      responsableLoading && (
                        <Col sm={1}>
                          <Spinner animation="border" size="sm" />
                        </Col>
                      )
                    }
                  </Row>
                  {
                    isRespValid && (
                      <div>
                        <small className="text-danger">**Campo requerido</small> 
                      </div>
                    )
                  }
                  <Button size="sm" className="rounded-pill mt-3" variant="primary" type="submit"><i className="material-icons">add</i> Agregar</Button>
                </Form>
              </Col>
              <Col sm={12} md={7}>
                <div className="my-1">
                  {
                    loadingWorkFlow ? (
                      <div className="d-flex justify-content-center">
                        <Spinner 
                          animation="border" 
                          role="status" 
                          className="d-flex justify-content-center" />
                      </div>
                    ) : workflowUsers.length > 0 ? (
                     <Table>
                       <thead>
                         <tr>
                           <th>Usuario</th>
                           <th>Responsable</th>
                           <th></th>
                         </tr>
                       </thead>
                       <tbody>
                       {
                          workflowUsers.map((workflowUser, ind) => (
                            <tr key={ind}>
                              <td>{workflowUser.user.label}</td>
                              <td>{workflowUser.resp.label}</td>
                              <td><Button variant="default" size="sm" className="ml-3" onClick={() => handleRemoveUserWork(ind)}><i className="material-icons" style={{fontSize: '1.3rem'}} >delete</i></Button></td>
                            </tr>
                          ))
                       }
                       </tbody>
                     </Table>
                    ): (
                      <Alert variant="info">
                        Aún no hay usuarios asignados a este WorkFlow.
                      </Alert>
                    )
                  }
                </div>
              </Col>
            </Row>
          </Card.Body>
        </Card>
      </Modal.Body>
      <Modal.Footer>
        <Button className="rounded-pill" variant="secondary" onClick={() => setWorkflowUsers([])}>
          Cancelar
        </Button>
        <Button 
          disabled={workflowUsers.length === 0 || saveLoading} 
          className="rounded-pill" 
          variant="primary" 
          type="button"
          onClick={() => handleSaveWorkFlowEmployees()}>
            {
              saveLoading ? (
                <Spinner
                className="mr-2"
                as="span"
                animation="border"
                size="sm"
                role="status"
                aria-hidden="true" />
                ): null
              }
          Guardar
        </Button>
      </Modal.Footer>
    </Modal>
  )
}

export default withRouter(WorkFlowEmployees)